import base from 'components/base'
import componentInit from 'components/componentInit'
import main from 'main'
import $ from 'jquery'

class mainMenu extends base
{
  elements = {
    outerWrapper: null,
    innerWrapper: null,
    container: null,
    closeButton: null,
    languageMenu: null,
    menu: null,
    links: [],
    spans: [],
    showChildrenButtons: [],
    hideChildrenButtons: [],
    siteTitle: null,
    metaContentLanguage: null,
    siteBody: null,
    siteWrapper: null,
    siteContent: null,
    shareButtons: null
  }

  scrollPoint = {}
  previousUrl = null

  closingAnimationDuration = 450
  closingTimeout = null

  constructor()
  {
    super()

    $(document).ready(() =>
    {
      this.elements.outerWrapper = $('#main-menu-outer-wrapper').get(0)
      this.elements.innerWrapper = $(this.elements.outerWrapper).children('.wrapper').get(0)
      this.elements.container = $(this.elements.innerWrapper).children('.content').get(0)
      this.elements.closeButton = $(this.elements.innerWrapper).find('.close-menu').get(0)
      this.elements.languageMenu = $(this.elements.container).children('#language-menu').get(0)
      this.elements.menu = $(this.elements.container).find('#main-menu').get()
      this.elements.links = $(this.elements.menu).find('a').get()
      this.elements.spans = $(this.elements.menu).find('span.has-children').get()

      this.elements.siteTitle = $('head > title').get(0)
      this.elements.metaContentLanguage = $('head > meta[http-equiv="Content-Language"]').get(0)
      this.elements.siteBody = $('body').get(0)
      this.elements.siteWrapper = $('#w').get(0)
      this.elements.siteContent = $('#site-content').get(0)
      this.elements.shareButtons = $('#share-buttons').get(0)

      this.createArrowButtons()
      this.bindEvents()
    })
  }

  createArrowButtons()
  {
    let uls = $(this.elements.menu).find('ul.children').get()
    for(let ul of uls)
    {
      let button = $('<button class="show-children"><div class="icon"></div></button>').get(0)
      $(button).insertBefore(ul)
      this.elements.showChildrenButtons.push(button)

      button = $('<button class="hide-children"><div class="icon"></div></button>').get(0)
      $(button).insertBefore(ul)
      this.elements.hideChildrenButtons.push(button)
    }
  }

  bindEvents()
  {
    $(this.elements.closeButton).on('click.'+ module.id, () =>
    {
      this.close({
        restoreScrollPoint: true
      })
    })

    $(this.elements.links).on('click.'+ module.id, (event) =>
    {
      let href = $(event.currentTarget).attr('href')
      if(href)
      {
        let urlType = this.getUrlType(href)
        if(urlType === 'internal')
        {
          event.preventDefault()
          this.changePage(href, {
            element: event.currentTarget
          })
        }
      }
    })

    $(this.elements.spans).on('click.'+ module.id, (event) =>
    {
      this.toggleChildren($(event.currentTarget).parent().get(0))
    })

    $(this.elements.showChildrenButtons).on('click.'+ module.id, (event) =>
    {
      this.showChildren($(event.currentTarget).parent().get(0))
    })

    $(this.elements.hideChildrenButtons).on('click.'+ module.id, (event) =>
    {
      this.hideChildren($(event.currentTarget).parent().get(0))
    })

    $(window).on('popstate.'+ module.id, (event) =>
    {
      // Change/load the page and instruct changeBrowserUrl() to not push
      // a state to history nor replace a state in it.
      this.changePage(window.location.href, {
        mode: 'skip',
        element: this.elements.siteContent,
        scrollToTop: false
      })
    })
  }

  open()
  {
    this.scrollPoint = {
      top: $(window).scrollTop(),
      left: $(window).scrollLeft()
    }

    let siteHeight = $(this.elements.siteWrapper).height()
    $(this.elements.innerWrapper).css('minHeight', siteHeight)
    $(this.elements.container).css('top', this.scrollPoint.top)

    $(this.elements.siteBody).toggleClass('main-menu-open', true)
    if(window.matchMedia && window.matchMedia('(max-width: 380px)').matches)
      window.scrollTo(0, 0)

    if(!$(this.elements.outerWrapper).hasClass('open'))
    {
      $(this.elements.outerWrapper).removeClass('closing').addClass('open')
      if(this.closingTimeout)
        clearTimeout(this.closingTimeout)
    }
  }

  close(params)
  {
    params = Object.assign({
      restoreScrollPoint: false
    }, params)

    $(this.elements.siteBody).toggleClass('main-menu-open', false)

    if(params.restoreScrollPoint && window.matchMedia && window.matchMedia('(max-width: 380px)').matches)
      window.scrollTo(this.scrollPoint.left, this.scrollPoint.top)

    if($(this.elements.outerWrapper).hasClass('open'))
    {
      $(this.elements.outerWrapper).removeClass('open').addClass('closing')

      if(this.closingTimeout)
        clearTimeout(this.closingTimeout)

      this.closingTimeout = setTimeout(() => {
        $(this.elements.outerWrapper).removeClass('closing')
      }, this.closingAnimationDuration)
    }
  }

  toggleChildren(menuItem)
  {
    if(!$(menuItem).hasClass('hide-children') && (
      $(menuItem).hasClass('show-children') || $(menuItem).hasClass('selected-child')))
      this.hideChildren(menuItem)
    else
      this.showChildren(menuItem)
  }

  showChildren(menuItem)
  {
    $(menuItem).toggleClass('show-children', true).removeClass('hide-children')
  }

  hideChildren(menuItem)
  {
    $(menuItem).toggleClass('hide-children', true).removeClass('show-children')
  }

  getUrlType(url)
  {
    if(url.match(/^#/))
      return 'anchor'

    else if(url.match(/^mailto:/i))
      return 'mailto'

    else if(url.match(/^tel:/i))
      return 'tel'

    else
    {
      if(url.match(new RegExp('^'+ main.framework.application.applicationUrl.replace(/\/*$/, ''), 'i')))
        return 'internal'
      else
        return 'external'
    }
  }

  changePage(url, params)
  {
    params = Object.assign({
      scrollToTop: true
    }, params)

    let queryParams = Object.assign(params, {
      url: url,
      outputType: 'html',
      events: {
        onSuccess: [(query) =>
        {
          let newContent = $('<div>'+ query.response +'</div>').get(0)

          // Update language menu.
          if(this.elements.languageMenu)
          {
            let newLanguageMenu = $(newContent).find('#language-menu').children().get()
            $(this.elements.languageMenu).empty().append(newLanguageMenu)
          }

          // Update share buttons.
          if(this.elements.shareButtons)
          {
            let newShareButtons = $(newContent).find('#share-buttons').children().get()
            $(this.elements.shareButtons).empty().append(newShareButtons)

            if(newShareButtons.length === 0)
              $(this.elements.shareButtons).parent().find('.search-input').show()
            else if($(this.elements.shareButtons).hasClass('open'))
              $(this.elements.shareButtons).parent().find('.search-input').hide()
          }

          else
          {
            this.elements.shareButtons = $(newContent).find('#share-buttons').get(0)
            $(this.elements.shareButtons).appendTo('#site-header > .center')
          }

          // Updated selected and selected-child classes in main menu.
          $(this.elements.links).removeClass('selected').parent().removeClass('selected')
          $(this.elements.menu).find('.selected-child').removeClass('selected-child')

          let currentLink = $(this.elements.links).filter('[href="'+ url +'"]').get(0)
          if(!currentLink)
            currentLink = $(this.elements.links).filter('[href="'+ url.replace(/\?+[^\?]*$/, '') +'"]').get(0)

          if(currentLink)
          {
            $(currentLink).addClass('selected').parent().addClass('selected')
            $(currentLink).parent().parents('li').addClass('selected-child').children('a, span').addClass('selected-child')
          }

          // Update site title.
          let siteTitle = query.response.match(/<title>\s*([^<]+)\s*<\/title>/)
          if(siteTitle && siteTitle[1] && siteTitle[1].length > 0)
            $(this.elements.siteTitle).text(siteTitle[1])

          // Update Content-Language meta tag.
          let contentLanguage = query.response.match(/<meta\s+http-equiv="Content-Language"\s+content="([^"]+)"/i)
          if(contentLanguage && contentLanguage[1] && contentLanguage[1].length > 0)
            $(this.elements.metaContentLanguage).attr('content', contentLanguage[1])

          // Update body classes.
          let bodyClasses = query.response.match(/<body[^>]*class="([^"]+)"/)
          $(this.elements.siteBody).removeAttr('class')
          if(bodyClasses && bodyClasses[1] && bodyClasses[1].length > 0)
            $(this.elements.siteBody).attr('class', bodyClasses[1])

          // Update site content.
          $(this.elements.siteContent).empty().append($(newContent).find('#site-content').children())

          // Initialise share buttons and components in site content.
          new componentInit([$(this.elements.shareButtons).parent().get(0), this.elements.siteContent]).run()

          this.changeBrowserUrl(url, params)
          this.close()

          if(params.scrollToTop)
            window.scrollTo(0, 0)

          // Remove existing show-children and hide-children classes from menu
          // items.
          $(this.elements.menu).find('li.show-children, li.hide-children').removeClass('show-children').removeClass('hide-children')

          if(typeof gtag === 'function')
          {
            gtag('set', {
              page_path: window.location.pathname
            })
            gtag('event', 'page_view')
          }
        }],
        onComplete: [(query) => {
          if(typeof params.callback === 'function')
            params.callback(query)
        }]
      }
    })

    this.runQuery(queryParams)
  }

  changeBrowserUrl(url, params)
  {
    params = Object.assign({
      mode: 'push'
    }, params)

    // Replace the state, if the URL is same as the previous URL.
    if(params.mode === 'push' && this.previousUrl === url)
      params.mode = 'replace'

    if(params.mode === 'push')
      history.pushState(null, null, url)

    else if(params.mode === 'replace')
      history.replaceState(null, null, url)

    this.previousUrl = url
  }
}

let instance = new mainMenu()

export default instance



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/mainMenu.js